class AuthManager {
  loginHandler(loginData) {
    const {token, userInfo, expiration} = loginData;
    localStorage.setItem('token', token);
    localStorage.setItem('expiration', expiration);
    localStorage.setItem('userInfo', JSON.stringify(userInfo));
  }

  logoutHandler() {
    localStorage.removeItem('token');
    localStorage.removeItem('expiration');
    localStorage.removeItem('userInfo');
    localStorage.removeItem('lastClicked');
    localStorage.removeItem('defaultItem');
    window.location.href = '/login';
  }

  async isLogin() {
    const token = await localStorage.getItem('token');
    // const expiration = localStorage.getItem('token_exp');

    if (token) {
      // Parse expiration date from token or retrieve it from local storage
      // const expirationDate = new Date(expiration);

      // Check if token is expired
      // if (expirationDate > new Date()) {
      //   // Token is valid, set isLoggedIn to true
      // } else {
      //   // Token has expired, clear local storage
      //   this.logoutHandler();
      // }

      // For simplicity, assuming token is always valid
      return true;
    } else {
      return false;
    }
  }
}

// Usage:
const authManager = new AuthManager();
export default authManager;
//
// // Call methods on the authManager instance
// authManager.loginHandler('your_token', 'expiration_date', 'user_info');
// authManager.logoutHandler();
// const loggedIn = await authManager.isLogin();
